module.exports = __webpack_public_path__ + "img/bank3.c67e0242.jpg";